import {
  BASE_URL,
  AUTH_LOGIN_URL,
  AUTH_REGISTER_URL,
  AUTH_LOGIN_ERROR,
  AUTH_LOGIN_LOADING,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT_LOADING,
  AUTH_LOGOUT_SUCCESS,
  AUTH_REGISTER_ERROR,
  AUTH_REGISTER_LOADING,
  AUTH_REGISTER_SUCCESS,
  AUTH_REGISTER_CHECK_URL,
  AUTH_REGISTER_CHECK_ERROR,
  AUTH_REGISTER_CHECK_LOADING,
  AUTH_REGISTER_CHECK_SUCCESS,
  ID_CONSIGNEE,
  ID_RESELLER,
  ID_SHIPPER,
} from "./constant";

const authLoginError = (bool) => {
  return {
    type: AUTH_LOGIN_ERROR,
    authLoginError: bool,
  };
};

const authLoginLoading = (bool) => {
  return {
    type: AUTH_LOGIN_LOADING,
    authLoginLoading: bool,
  };
};

const authLoginSuccess = (bool, account) => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    authLoginSuccess: bool,
    isAuthenticated: bool,
    account,
  };
};

const isExpiredData = (pi_expired, skip, pi_status) => {
  return {
    type: "PI_EXPIRED",
    pi_expired: pi_expired,
    skip: skip,
    pi_status: pi_status,
  };
};

export function doLogin(cred) {
  return async (dispatch) => {
    dispatch(authLoginSuccess(false, null));
    dispatch(authLoginError(false));
    dispatch(authLoginLoading(true));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: cred.email,
        password: cred.password,
        usery_type_id: cred.usery_type_id,
      }),
    };
    fetch(BASE_URL + AUTH_LOGIN_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(authLoginLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then(async (account) => {
        localStorage.removeItem("tolaut@email");
        localStorage.removeItem("tolaut@typeUser");
        localStorage.removeItem("tolaut@token");
        localStorage.removeItem("tolaut@userId");
        localStorage.removeItem("tolaut@form");
        localStorage.removeItem("tolaut@consignee_type");
        localStorage.removeItem("tolaut@reseller_type");
        localStorage.removeItem("tolaut@pi_expired");
        localStorage.removeItem("tolaut@skip");
        await localStorage.clear();

        account.data.all_actions.map(async (val, idx) => {
          await localStorage.removeItem(
            `tolaut@${val.action_key}`,
            val.allowed
          );
        });

        if (account.success) {
          localStorage.setItem("tolaut@email", account.data.user[0].email);
          localStorage.setItem("tolaut@typeUser", cred.usery_type_id);
          localStorage.setItem("tolaut@token", account.token);
          localStorage.setItem("tolaut@userId", account.data.user[0].id);
          localStorage.setItem("tolaut@form", account.data.form);
          localStorage.setItem(
            "tolaut@consignee_type",
            account.data.consignee_type
          );
          localStorage.setItem(
            "tolaut@reseller_type",
            account.data.reseller_type
          );
          if (cred.usery_type_id === 5) {
            if (account.data.expired_status === true) {
              await localStorage.setItem(
                `tolaut@user_can_view_operator_list`,
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_sisa_quota_trayek",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_latest_vessel_booking",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_latest_jadwal_kapal",
                true
              );
              await localStorage.setItem("tolaut@user_can_manifest_list", true);
              await localStorage.setItem("tolaut@user_can_booking_list", true);
              await localStorage.setItem("tolaut@user_can_jadwal_list", true);
              await localStorage.setItem(
                "tolaut@user_can_tracking_data_list",
                true
              );
              await localStorage.setItem("tolaut@user_can_trayek_list", true);
              await localStorage.setItem("tolaut@user_can_kapal_list", true);
              await localStorage.setItem("tolaut@user_can_depot_list", true);
              await localStorage.setItem(
                "tolaut@user_can_pengaduan_list",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_pelabuhan_list",
                true
              );
            } else {
              account.data.acl.map(async (val) => {
                await localStorage.setItem(
                  `tolaut@${val.action_key}`,
                  val.allowed
                );
              });
            }
          } else {
            account.data.acl.map((val, idx) => {
              localStorage.setItem(`tolaut@${val.action_key}`, val.allowed);
            });
          }

          if (
            account.data.user[0].usery_type_id === ID_CONSIGNEE ||
            account.data.user[0].usery_type_id === ID_RESELLER ||
            account.data.user[0].usery_type_id === ID_SHIPPER
          ) {
            localStorage.setItem("tolaut@pi_expired", account.data.expired_pi);
            localStorage.setItem("tolaut@skip", account.data.skip);
            localStorage.setItem("tolaut@status_pi", account.data.status_pi);
            localStorage.setItem("tolaut@status", account.data.user[0].status);
            // localStorage.setItem("tolaut@status", "-7")
            dispatch(
              isExpiredData(
                account.data.expired_pi,
                account.data.skip,
                account.data.status_pi
              )
            );
            if (account.data.expired_pi === true) {
              if (account.data.status_pi === 2) {
                window.alert(
                  "Pakta integritas anda ditolak!!! Mohon update kembali pakta integritas anda"
                );
              } else {
                window.alert("Mohon update pakta integritas anda");
              }
            }
          }
          dispatch(authLoginSuccess(true, account));
        } else {
          dispatch(authLoginError(true));
        }
      })
      .catch((err) => {
        dispatch(authLoginError(true));
      });
  };
}

export function doLoginSSO() {
  return async (dispatch) => {
    dispatch(authLoginSuccess(false, null));
    dispatch(authLoginError(false));
    dispatch(authLoginLoading(true));

    // let token = JSON.parse(
    //   sessionStorage.getItem(
    //     `oidc.user:https://sso-dev.hubla.dephub.go.id/realms/djpl:sitolaut`
    //   )
    // );

    let token = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:https://sso-maritim.kemenhub.go.id/realms/djpl:sitolaut`
      )
    );
    const accessToken = token.access_token;

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      // body: JSON.stringify({
      //   email: cred.email,
      //   password: cred.password,
      //   usery_type_id: cred.usery_type_id,
      // }),
    };
    fetch(BASE_URL + "login-sso", config)
      .then((response) => {
        console.log("response", response);
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(authLoginLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then(async (account) => {
        console.log("account", account);
        localStorage.removeItem("tolaut@email");
        localStorage.removeItem("tolaut@typeUser");
        localStorage.removeItem("tolaut@token");
        localStorage.removeItem("tolaut@userId");
        localStorage.removeItem("tolaut@form");
        localStorage.removeItem("tolaut@consignee_type");
        localStorage.removeItem("tolaut@reseller_type");
        localStorage.removeItem("tolaut@pi_expired");
        localStorage.removeItem("tolaut@skip");
        await localStorage.clear();

        account.data.all_actions.map(async (val, idx) => {
          await localStorage.removeItem(
            `tolaut@${val.action_key}`,
            val.allowed
          );
        });

        if (account.success) {
          localStorage.setItem("tolaut@email", account.data.user[0].email);
          localStorage.setItem(
            "tolaut@typeUser",
            account.data.user[0].usery_type_id
          );
          localStorage.setItem("tolaut@token", account.token);
          localStorage.setItem("tolaut@userId", account.data.user[0].id);
          localStorage.setItem("tolaut@form", account.data.form);
          localStorage.setItem(
            "tolaut@consignee_type",
            account.data.consignee_type
          );
          localStorage.setItem(
            "tolaut@reseller_type",
            account.data.reseller_type
          );
          if (account.data.user[0].usery_type_id === 5) {
            if (account.data.expired_status === true) {
              await localStorage.setItem(
                `tolaut@user_can_view_operator_list`,
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_sisa_quota_trayek",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_latest_vessel_booking",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_view_latest_jadwal_kapal",
                true
              );
              await localStorage.setItem("tolaut@user_can_manifest_list", true);
              await localStorage.setItem("tolaut@user_can_booking_list", true);
              await localStorage.setItem("tolaut@user_can_jadwal_list", true);
              await localStorage.setItem(
                "tolaut@user_can_tracking_data_list",
                true
              );
              await localStorage.setItem("tolaut@user_can_trayek_list", true);
              await localStorage.setItem("tolaut@user_can_kapal_list", true);
              await localStorage.setItem("tolaut@user_can_depot_list", true);
              await localStorage.setItem(
                "tolaut@user_can_pengaduan_list",
                true
              );
              await localStorage.setItem(
                "tolaut@user_can_pelabuhan_list",
                true
              );
            } else {
              account.data.acl.map(async (val) => {
                await localStorage.setItem(
                  `tolaut@${val.action_key}`,
                  val.allowed
                );
              });
            }
          } else {
            account.data.acl.map((val, idx) => {
              localStorage.setItem(`tolaut@${val.action_key}`, val.allowed);
            });
          }

          if (
            account.data.user[0].usery_type_id === ID_CONSIGNEE ||
            account.data.user[0].usery_type_id === ID_RESELLER ||
            account.data.user[0].usery_type_id === ID_SHIPPER
          ) {
            localStorage.setItem("tolaut@pi_expired", account.data.expired_pi);
            localStorage.setItem("tolaut@skip", account.data.skip);
            localStorage.setItem("tolaut@status_pi", account.data.status_pi);
            localStorage.setItem("tolaut@status", account.data.user[0].status);
            // localStorage.setItem("tolaut@status", "-7")
            dispatch(
              isExpiredData(
                account.data.expired_pi,
                account.data.skip,
                account.data.status_pi
              )
            );
            if (account.data.expired_pi === true) {
              if (account.data.status_pi === 2) {
                window.alert(
                  "Pakta integritas anda ditolak!!! Mohon update kembali pakta integritas anda"
                );
              } else {
                window.alert("Mohon update pakta integritas anda");
              }
            }
          }
          dispatch(authLoginSuccess(true, account));
        } else {
          dispatch(authLoginError(true));
        }
      })
      .catch((err) => {
        dispatch(authLoginError(true));
      });
  };
}

const authRegisterError = (bool) => {
  return {
    type: AUTH_REGISTER_ERROR,
    authRegisterError: bool,
  };
};

const authRegisterLoading = (bool) => {
  return {
    type: AUTH_REGISTER_LOADING,
    authRegisterLoading: bool,
  };
};

const authRegisterSuccess = (bool, account) => {
  return {
    type: AUTH_REGISTER_SUCCESS,
    authRegisterSuccess: bool,
    isAuthenticated: bool,
    account,
  };
};

export function doRegister(cred) {
  return (dispatch) => {
    dispatch(authRegisterSuccess(false, null));
    dispatch(authRegisterError(false));
    dispatch(authRegisterLoading(true));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: cred.email,
        password: cred.password,
        usery_type_id: cred.usery_type_id,
      }),
    };
    fetch(BASE_URL + AUTH_REGISTER_URL, config)
      .then((response) => {
        if (!response.ok) {
          dispatch(authRegisterError(true));
        }
        dispatch(authRegisterLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((account) => {
        if (account.success) {
          dispatch(authRegisterSuccess(true, account));
        } else {
          dispatch(authRegisterError(true));
        }
      })
      .catch((err) => {
        dispatch(authRegisterError(true));
      });
  };
}

const authLogoutLoading = (bool) => {
  return {
    type: AUTH_LOGOUT_LOADING,
    authLogoutLoading: bool,
  };
};

const authLogoutSuccess = (bool) => {
  return {
    type: AUTH_LOGOUT_SUCCESS,
    authLogoutSuccess: bool,
    isAuthenticated: !bool,
  };
};

export function doLogout() {
  return async (dispatch) => {
    await dispatch(authLogoutLoading(true));
    await localStorage.removeItem("tolaut@email");
    await localStorage.removeItem("tolaut@typeUser");
    await localStorage.removeItem("tolaut@userId");
    await localStorage.removeItem("tolaut@token");
    await localStorage.removeItem("tolaut@consignee_type");
    await localStorage.removeItem("tolaut@reseller_type");
    localStorage.removeItem("tolaut@pi_expired");
    localStorage.removeItem("tolaut@skip");
    localStorage.removeItem("tolaut@status_pi");
    await localStorage.clear();
    await dispatch(authLogoutLoading(false));
    await dispatch(authLogoutSuccess(true));
  };
}

const authRegisterCheckError = (bool, check_data) => {
  return {
    type: AUTH_REGISTER_CHECK_ERROR,
    authRegisterCheckError: bool,
    check_data,
  };
};

const authRegisterCheckLoading = (bool) => {
  return {
    type: AUTH_REGISTER_CHECK_LOADING,
    authRegisterCheckLoading: bool,
  };
};

const authRegisterCheckSuccess = (bool, check_data) => {
  return {
    type: AUTH_REGISTER_CHECK_SUCCESS,
    authRegisterCheckSuccess: bool,
    isAuthenticated: bool,
    check_data,
  };
};

export function doRegisterCheck(cred) {
  return (dispatch) => {
    dispatch(authRegisterCheckSuccess(false, null));
    dispatch(authRegisterCheckError(false, null));
    dispatch(authRegisterCheckLoading(true));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: cred.email,
        usery_type_id: cred.usery_type_id,
        password: cred.password,
        confirm_password: cred.confirm_password,
      }),
    };
    fetch(BASE_URL + AUTH_REGISTER_CHECK_URL, config)
      .then((response) => {
        if (!response.ok) {
          dispatch(authRegisterCheckError(true));
        }
        dispatch(authRegisterCheckLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((check_data) => {
        if (check_data.success) {
          dispatch(authRegisterCheckSuccess(true, check_data));
        } else {
          dispatch(authRegisterCheckError(true, check_data));
        }
      })
      .catch((err) => {
        dispatch(authRegisterCheckError(true, err));
      });
  };
}
